import {
  Button,
  Card,
  Heading,
  Paragraph,
  Tag,
} from "@digdir/designsystemet-react";
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { cn } from "@/utils";

export const SimuleringsområdeLenke = ({
  className,
}: {
  className?: string;
}) => {
  const { t } = useTranslation();

  return (
    <Card>
      <Tag
        className={cn(
          "bg-balder-support-surface-tinted! text-balder-text-support-default!",
          className,
        )}
      >
        {t("pages.simulering.tag")}
      </Tag>
      <Heading>{t("pages.simulering.tittel")}</Heading>
      <Paragraph>{t("pages.simulering.lenke-description")}</Paragraph>
      <Button variant="secondary" asChild className="w-fit">
        <Link to={"/maalerdata/simulering"}>{t("pages.simulering.link")}</Link>
      </Button>
    </Card>
  );
};
